var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7ZM7.8 3.8C7.8 4.24183 7.44183 4.6 7 4.6C6.55817 4.6 6.2 4.24183 6.2 3.8C6.2 3.35817 6.55817 3 7 3C7.44183 3 7.8 3.35817 7.8 3.8ZM7 6C7.33137 6 7.6 6.26863 7.6 6.6V10.6C7.6 10.9314 7.33137 11.2 7 11.2C6.66863 11.2 6.4 10.9314 6.4 10.6V6.6C6.4 6.26863 6.66863 6 7 6Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/HelpIcon.3b46f88ddf6d1b52f188268df7851578.svg";
export { ForwardRef as ReactComponent };